import React, { useEffect, useRef, useState } from "react";
import { jwtDecode } from "jwt-decode";

function getFromToken() {
  const token = localStorage.getItem("token");
  if (!token) return { email: "", role: "" };
  try {
    const decoded = jwtDecode(token);
    return { email: decoded?.email || "", role: decoded?.role || "" };
  } catch {
    return { email: "", role: "" };
  }
}

export default function TopNav({ isLoggedIn, onLogout, onNavigate, role, hideLogin }) {
  const { email, role: tokenRole } = isLoggedIn ? getFromToken() : { email: "", role: "" };
  const userRole = role || tokenRole;
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    function onDocClick(e) {
      if (!wrapRef.current) return;
      if (!wrapRef.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener("click", onDocClick);
    return () => document.removeEventListener("click", onDocClick);
  }, []);

  return (
    <header className="app-header">
      <div className="app-header__inner">
        <div style={{ display: "flex", alignItems: "center", gap: 6, cursor: "pointer", fontWeight: 600, fontSize: 18 }} onClick={() => onNavigate?.("home")}>
          <svg width="22" height="22" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="100" cy="100" r="63.75" stroke="#6E56CF" strokeWidth="0.8" strokeOpacity="0.25" fill="none" />
            <path d="M165 135 A 75 75 0 1 0 135 165" stroke="#6E56CF" strokeWidth="1.8" strokeLinecap="round" fill="none" />
            <line x1="106.25" y1="100" x2="165" y2="135" stroke="#6E56CF" strokeWidth="0.8" strokeOpacity="0.12" />
            <line x1="100" y1="106.25" x2="135" y2="165" stroke="#6E56CF" strokeWidth="0.8" strokeOpacity="0.12" />
            <path d="M165 135 A 75 75 0 0 1 135 165" stroke="#A88FFF" strokeWidth="4" strokeLinecap="round" fill="none" transform="scale(0.92) translate(8.7, 8.7)" />
            <rect x="93.75" y="93.75" width="12.5" height="12.5" fill="#6E56CF" transform="rotate(45 100 100)" />
          </svg>
          <span style={{ letterSpacing: "-0.04em", color: "currentColor" }}>
            Solv<span style={{ color: "#6E56CF", fontWeight: 600 }}>ya</span>
          </span>
          <span className="beta-badge" style={{ fontSize: 9, padding: '2px 6px' }}>BETA</span>
        </div>

        <nav className="topnav">
          {isLoggedIn && (
            <button className="nav-link" type="button" onClick={() => onNavigate?.("home")}>Tableau de bord</button>
          )}

          {isLoggedIn ? (
            <>
              <div className="account-dd" ref={wrapRef}>
                <button
                  type="button"
                  className={`nav-link account-trigger ${open ? "open" : ""}`}
                  onClick={() => setOpen(v => !v)}
                  aria-haspopup="menu"
                  aria-expanded={open ? "true" : "false"}
                  style={{ display: "flex", alignItems: "center", gap: 4 }}
                >
                  Mon compte <span className="account-caret">▾</span>
                </button>

                <div className={`account-menu ${open ? "open" : ""}`} role="menu" aria-label="Menu compte">
                  <div className="account-email" title={email || ""}>
                    {email || "—"}
                  </div>
                  <button className="account-item" type="button" onClick={(e) => { e.stopPropagation(); onNavigate?.("my-account"); }}>
                    Mon compte
                  </button>
                  {userRole !== 'technicien' && (
                    <>
                      <button className="account-item" type="button" onClick={(e) => { e.stopPropagation(); onNavigate?.("payment-methods"); setOpen(false); }}>
                        Modes de paiement
                      </button>
                      <button className="account-item" type="button" onClick={(e) => { e.stopPropagation(); onNavigate?.("interventions"); setOpen(false); }}>
                        Mes factures
                      </button>
                    </>
                  )}
                  {userRole === 'technicien' && (
                    <button className="account-item" type="button" onClick={(e) => { e.stopPropagation(); onNavigate?.("technician-payout"); setOpen(false); }}>
                      Mes paiements
                    </button>
                  )}
                  <div className="account-sep" />
                  <button className="account-item account-logout" type="button" onClick={onLogout}>
                    Déconnexion
                  </button>
                </div>
              </div>

              {userRole !== 'technicien' && (
                <button
                  className="nav-cta"
                  type="button"
                  onClick={() => onNavigate?.("become-technician")}
                >
                  Devenir technicien
                </button>
              )}
            </>
          ) : !hideLogin ? (
            <a className="nav-link" href="/login">Connexion</a>
          ) : null}
        </nav>
      </div>
    </header>
  );
}